import {
  // SET_PLAYER_EDITING_DATA,
  SET_XML_STRING_ARRAY,
  SET_FIND_ALL_INPUT,
  SET_FIND_ALL_LIST,
  SET_FIND_ALL_TARGETSTRING,
  SET_IS_EDITMODE,
  SET_FIND_ALL_TARGET_DATA,
  SET_FIND_ALL_SELECT_ROW_COL,
  SET_FIND_ALL_SHOW_REPLACE,
  SET_FIND_AND_REPLACE_SELECT_ROW_COL,
  SET_FIND_AND_REPLACE_SENTENCE,
  SET_FIND_AND_REPLACE_DATA,
  UPDATE_WAVE_VIDEO_CURRENT_TIME,
  SET_VIDEO_FPS,
} from '../actions/types';

const initialState = {
  xmlStringArray: [],
  videoFps: 23.98, //frame數量
  frameWidth: 2.76, //frame的寬度
  //playerEditingData : [],
  transHeaderColumns: [
    'In',
    'Out',
    'Shot Change',
    'Duration',
    'Annotation',
    'Memo',
    'FX',
    'Source',
    'Loaded',
    'Subtitle',
    'Compare',
    'Length',
    'Position',
    'ShotChangeSecond',
    'ShotChangeArray',
    'ShotChangeTitle',
    'isIgnoreShotchange',
    'isInShotChangeActive',
    'isOutShotChangeActive',
  ],
  transHeaderNameColumns: [
    'In',
    'Out',
    'Shot Change',
    'Duration',
    'Annotation',
    'Memo',
    'FX',
    'Source',
    'Loaded',
    'Subtitle',
    'Compare',
    'Length',
    'Position',
    'ShotChangeSecond',
    'ShotChangeArray',
    'ShotChangeTitle',
    'isIgnoreShotchange',
    'isInShotChangeActive',
    'isOutShotChangeActive',
  ],

  tableColMapping: {
    In: 0,
    Out: 1,
    ShotChange: 2,
    Duration: 3,
    Annotation: 4,
    Memo: 5,
    FX: 6,
    Source: 7,
    Loaded: 8,
    SubtitleCaption: 9,
    Compare: 10,
    Length: 11,
    Position: 12,
    ShotChangeSecond:13,
    ShotChangeArray:14,
    ShotChangeTitle:15,
    isIgnoreShotchange:16,
    isInShotChangeActive:17,
    isOutShotChangeActive:18,
  }, //在cells裡面對應的index整理

  tableColNameMapping: {
    SubtitleCaption: 'Sub/CC',
    Memo: 'Memo',
    Source: 'Source',
  }, //在cells裡面對應的index整理

  findAllTargetString: '', //全域搜尋

  isEditMode: false,

  findAllTargetData: [], //目標資料

  findAndReplaceData: [], //替代搜尋到的目標
  findAndReplaceSelectRowCol: null, //替代目標位置
  findAndReplaceSentence: '', //替代目標的句子

  isShowFindAllViewInput: false, //搜尋全部的輸入
  isShowFindAllViewList: false, //搜尋全部的顯示
  isShowFindAllViewReplace: false, //替換的顯示

  allDurationArray: [], //所有的Duration 資料

  WAVE_videoCurrentTime: 0, //拖拉的時間
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_VIDEO_FPS:
      return {
        ...state,
        videoFps: action.payload,
      };

    case UPDATE_WAVE_VIDEO_CURRENT_TIME:
      return {
        ...state,
        WAVE_videoCurrentTime: action.payload,
      };

    case SET_FIND_AND_REPLACE_SENTENCE:
      return {
        ...state,
        findAndReplaceSentence: action.payload,
      };

    case SET_FIND_ALL_SHOW_REPLACE:
      return {
        ...state,
        isShowFindAllViewReplace: action.payload,
      };

    case SET_FIND_AND_REPLACE_DATA:
      return {
        ...state,
        findAndReplaceData: action.payload,
      };

    case SET_FIND_AND_REPLACE_SELECT_ROW_COL:
      return {
        ...state,
        findAndReplaceSelectRowCol: action.payload,
      };

    case SET_FIND_ALL_TARGET_DATA:
      return {
        ...state,
        findAllTargetData: action.payload,
      };

    case SET_IS_EDITMODE:
      return {
        ...state,
        isEditMode: action.payload,
      };

    case SET_FIND_ALL_TARGETSTRING:
      return {
        ...state,
        findAllTargetString: action.payload,
      };

    case SET_FIND_ALL_INPUT:
      return {
        ...state,
        isShowFindAllViewInput: action.payload,
      };

    case SET_FIND_ALL_LIST:
      return {
        ...state,
        isShowFindAllViewList: action.payload,
      };

    // case SET_PLAYER_EDITING_DATA:
    //
    //     let newPlayerEditingData = action.payload;
    //
    //
    //     return {
    //         ...state,
    //         playerEditingData: newPlayerEditingData
    //     };

    case SET_XML_STRING_ARRAY:
      return {
        ...state,
        xmlStringArray: action.payload,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/TransOperationReducer.js